/* Box Protéica — lógica de la PDP */
(function () {
  'use strict';

  // ── Ocultar header/announcement/footer nativos del theme ──
  function hideNativeChrome() {
    var page = document.querySelector('.box-proteica-page');
    if (!page) return;
    var node = page;
    while (node.parentElement && node.parentElement !== document.body) {
      node = node.parentElement;
    }
    Array.prototype.forEach.call(document.body.children, function (child) {
      if (child === node) return;
      var tag = child.tagName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT') return;
      var cs = window.getComputedStyle(child);
      // Preservar widgets fixed con z-index alto (WhatsApp, etc.)
      if (cs.position === 'fixed' && parseInt(cs.zIndex, 10) > 100) return;
      child.style.display = 'none';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideNativeChrome);
  } else {
    hideNativeChrome();
  }

  // ── Precio dinámico desde Shopify (window.BOX_PRICE / BOX_COMPARE en pesos) ──
  var UNIT = (typeof window.BOX_PRICE === 'number' && window.BOX_PRICE > 0) ? window.BOX_PRICE : 170000;
  var COMPARE = (typeof window.BOX_COMPARE === 'number') ? window.BOX_COMPARE : 0; // 0 = sin tachado
  var PORTIONS = 35; // 7 kg ≈ 35 platos de ~200g; los 30 huevos van de yapa. Ajustable.
  function fmt(n) { return '$' + Math.round(n).toLocaleString('es-AR'); }

  var hasCompare = COMPARE && COMPARE > UNIT;
  var perPlato = Math.round(UNIT / PORTIONS / 100) * 100;
  document.querySelectorAll('.box-proteica-page [data-role="price"]').forEach(function (el) { el.textContent = fmt(UNIT); });
  document.querySelectorAll('.box-proteica-page [data-role="per-plato"]').forEach(function (el) { el.textContent = fmt(perPlato); });
  document.querySelectorAll('.box-proteica-page [data-role="compare"]').forEach(function (el) {
    el.style.display = hasCompare ? '' : 'none';
    if (hasCompare) el.textContent = fmt(COMPARE);
  });

  // ── Banner sticky inferior que crece al scroll ──
  (function () {
    var banner = document.getElementById('tbar');
    if (!banner) return;
    var ticking = false;
    function update() {
      var y = window.scrollY;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      var p = h > 0 ? y / h : 0;
      banner.classList.remove('is-grown', 'is-mega');
      if (p >= 0.75) banner.classList.add('is-mega');
      else if (y > 200) banner.classList.add('is-grown');
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  })();

  // ── Hero carousel: slide horizontal ──
  (function () {
    var slides = document.querySelectorAll('.box-proteica-page .hero-slide');
    if (slides.length < 2) return;
    var i = 0;
    setInterval(function () {
      var cur = slides[i];
      var nextI = (i + 1) % slides.length;
      var nxt = slides[nextI];
      cur.classList.remove('is-active');
      cur.classList.add('is-leaving');
      nxt.classList.add('is-active');
      (function (leaving) {
        setTimeout(function () {
          leaving.style.transition = 'none';
          leaving.classList.remove('is-leaving');
          void leaving.offsetWidth;
          leaving.style.transition = '';
        }, 650);
      })(cur);
      i = nextI;
    }, 2800);
  })();

  // ── FAQ accordion ──
  document.querySelectorAll('.box-proteica-page .faq-item').forEach(function (item) {
    var row = item.querySelector('.faq-q-row');
    if (!row) return;
    row.addEventListener('click', function () { item.classList.toggle('open'); });
  });

  // ── Qty + breakdown en vivo (todo deriva de UNIT = product.price) ──
  var qty = 1, MIN = 1, MAX = 5;
  function updatePrices() {
    var total = UNIT * qty;
    var setText = function (id, txt) { var el = document.getElementById(id); if (el) el.textContent = txt; };
    setText('qty-display', qty);
    setText('bd-box-label', 'Box Protéica × ' + qty);
    setText('bd-box-val', fmt(total));
    setText('bd-total', fmt(total));
    setText('btn-total', fmt(total));
    var minus = document.getElementById('qty-minus');
    var plus = document.getElementById('qty-plus');
    if (minus) minus.disabled = qty <= MIN;
    if (plus) plus.disabled = qty >= MAX;
  }
  window.changeQty = function (d) {
    qty = Math.max(MIN, Math.min(MAX, qty + d));
    updatePrices();
  };

  // ── Shopify Cart API: agregar Box al carrito + redirect a /checkout ──
  window.handleBuyBox = async function () {
    var variantId = window.BOX_VARIANT_ID;
    if (!variantId) { console.error('Box: variant ID no definido'); return; }
    var btns = document.querySelectorAll('.box-proteica-page .fc-btn');
    btns.forEach(function (b) { b.disabled = true; });
    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
      });
      if (response.ok) {
        window.location.href = '/checkout';
      } else {
        console.error('Box: error al agregar al carrito', await response.text());
        btns.forEach(function (b) { b.disabled = false; });
      }
    } catch (err) {
      console.error('Box: error de red', err);
      btns.forEach(function (b) { b.disabled = false; });
    }
  };

  // init
  updatePrices();
})();
